<template>
    <div class="all-networks">
        <div class="all-networks__header" @click="resetView">
            <div class="all-networks__header__left">
                <span>{{ NetworkConstants.NETWORK_HEADING }}</span>
            </div>
            <div class="all-networks__header__right" v-if="!isMobileOrSmall || expandedCategoryIndex === null">
                <p>{{ NetworkConstants.NETWORK_RIGHT_HEADING }}</p>
                <p>{{ NetworkConstants.COMMUNITIES_PILOT }} <a :href="NetworkConstants.COMMUNITIES_PILOT_LINK" target="_self">here</a>.</p>
            </div>
        </div>

        <div v-if="isMobileOrSmall">
            <div v-for="(category, index) in getCardData" :key="index" class="network-section"
                v-if="expandedCategoryIndex === null || expandedCategoryIndex === index">
                <div class="network-section__category-title" v-html="category.title"></div>
                <div v-if="expandedCategoryIndex === index">
                    <div class="network-section__container-vertical ">
                        <div v-for="(card, cardIndex) in category.cards" :key="cardIndex"
                            class="network-section__content-mobile network-section__content-mobile--expanded">
                            <network-card :network="card"></network-card>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="network-section__container-horizontal">
                        <div v-for="(card, cardIndex) in visibleCards(category.cards)" :key="cardIndex"
                            class="network-section__content-mobile">
                            <network-card :network="card"></network-card>
                        </div>
                        <div v-if="category.cards.length > NetworkConstants.MAX_NETWORK_CARDS_TO_SHOW" class="network-section__content-mobile see-all-card"
                            @click="toggleSeeAll(index)">
                            <div class="see-all-text">{{NetworkConstants.SEE_ALL}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <v-expansion-panel expand v-model="networkExpansionPanel" id="network-expansion-panel" class="network-expansion">
                <v-expansion-panel-content v-for="(category, index) in getCardData" :key="index" :value="category.expanded"
                 class="network-section">
                    <div slot="header">
                        <div class="network-section__category-title" v-html="category.title"></div>
                    </div>
                    <v-layout class="network-section__container flex-grow-overwrite-all" row wrap>
                        <v-flex v-for="(card, cardIndex) in category.cards" :key="cardIndex"
                            class="network-section__content">
                            <network-card :network="card"></network-card>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
    </div>
</template>





<script>
    import NetworkCard from './NetworkCard.vue';
    import { mapActions, mapGetters } from "vuex";
    import { storeAction } from "@/store/storeActions.constant";
    import { storeGetters } from "@/store/storeGetters.constant";
    import { getYPONetworksData } from "./networkPageUtils";
    import { NetworkConstants } from "./NetworkConstants";

export default {
    components: {
        NetworkCard,
    },
    data() {
        return {
            NetworkConstants,
            expandedPanels: [],
            allYPONetworks: [],
            networkExpansionPanel: [],
            expandedCategoryIndex: null,
        };
    },
    async created() {
        this.networkExpansionPanel = [1];
        await this.getAllNetworks();
    },
    methods: {
        ...mapActions({
            getAllNetworks: `network/${storeAction.getAllNetworks}`,
        }),
        visibleCards(cards) {
            return cards.slice(0, NetworkConstants.MAX_NETWORK_CARDS_TO_SHOW);
        },
        toggleSeeAll(index) {
            this.expandedCategoryIndex = this.expandedCategoryIndex === index ? null : index;
        },
        resetView() {
            this.expandedCategoryIndex = null;
        }
    },
    computed: {
        ...mapGetters({
            allNetworks: `network/${storeGetters.allNetworks}`,
        }),
        getCardData() {
            return getYPONetworksData(this.allNetworks);
        },
        isMobileOrSmall() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    }
};
</script>


<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import "../../common/styles/responsive.scss";

.all-networks {
    position: relative;
    min-height: 350px;
    max-width: 2200px;
    margin: 55px auto 0;
    height: 100%;
    background: white;

    &__header {
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        text-align: center;
        padding: 20px;

        @include breakpoint(xs) {
            display: block;
            text-align: left;
            padding: 15px;

            &__left,
            &__right {
                width: 100%;
                margin: 10px 0;
            }
        }

        &__left {
            font-size: 32px;
            font-weight: 500;
            text-align: left;
            min-width: 250px;
            float: left;

            @include breakpoint(xs) {
                font-size: 24px;
                display: block;
                width: 100%;
                text-align: left;
                margin: 0;
                font-weight: 600;
            }
        }

        &__right {
            display: inline-block;
            font-size: 18px;
            width: 80%;
            text-align: left;
            margin-top: 10px;

            @include breakpoint(xs) {
                font-size: 14px;
                display: block;
                width: 100%;
                text-align: left;
                margin-top: 40px;
            }
          @include breakpoint(xs) {
               padding-right: 10%;
          }
          @include breakpoint(sm) {
            padding-right: 10%;
          }
          @include breakpoint(md) {
            padding-right: 10%;
          }
          @include breakpoint(lg) {
            padding-right: 0;
          }
        }
    }

    .network-section {
        &__category-title {
            font-size: 20px;
            color: $ypo_blue;
            font-weight: 300;
            @include breakpoint(xs) {
                margin-top: 20px;
                margin-left: 15px;
                max-width: 300px ;
            }
            @include breakpoint(sm) {
                margin-top: 20px;
                margin-left: 15px;
                max-width: 300px ;
            }
        }

        &__container-horizontal {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            padding-right: 25px;
            width: 100%;
            -ms-overflow-style: none;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }

            &__content-mobile {
                min-width: 200px;
                flex: 0 0 auto;
                margin-right: 10px;
            }
        }

        &__container-vertical {
            display: flex;
            flex-direction: column;
            padding: 5px 15px;
            width: 100%;
            &__content-mobile {
                margin-bottom: 10px;
            }
        }

        .see-all-card {
            margin: 18px;
            min-width: 320px;
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $ypo-gold;
            color: white;
            border-radius: 15px;
            cursor: pointer;
        }

        .see-all-text {
            padding: 8px;
            text-align: center;
            font-weight: 700;
            font-size: 15px;
            color: $ypo-primary-blue;
        }
    }
}
</style>

<style lang="scss">
#network-expansion-panel .v-expansion-panel__header {
    width: 340px;
}
.network-expansion {
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0), 0 1px 3px 0 rgba(0, 0, 0, 0);
}
.theme--light.v-expansion-panel .v-expansion-panel__container {
        border-top: 1px solid rgba(0, 0, 0, 0);
    }
.network-section__content-mobile--expanded {
    .network-card {
        margin: 10px 0;
        width: 100%;
    }
}
.member-only-note {
    font-style: italic;
    font-size: 16px;
}
</style>
